import React, { createContext, useContext, useState } from "react";

export const FormContext = createContext(); // ✅ Export qilindi

export function FormProvider({ children }) {
  const [formData, setFormData] = useState({
    name: "",
    selectedBouquets: [],
    selectedColors: [],
    ratings: {},
  });

  const [uuid, setUUID] = useState(null);
  return (
    <FormContext.Provider value={{ formData, setFormData, uuid, setUUID }}>
      {children}
    </FormContext.Provider>
  );
}

export function useFormData() {
  return useContext(FormContext);
}
